// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tags = /** @type {(inputs: {}) => string} */ () => {
	return `Tags`
};

const el_tags = /** @type {(inputs: {}) => string} */ () => {
	return `Ετικέτες`
};

const ru_tags = /** @type {(inputs: {}) => string} */ () => {
	return `Теги`
};

const he_tags = /** @type {(inputs: {}) => string} */ () => {
	return `תגיות`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tags = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tags(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tags", locale)
	if (locale === "en") return en_tags(inputs)
	if (locale === "el") return el_tags(inputs)
	if (locale === "ru") return ru_tags(inputs)
	if (locale === "he") return he_tags(inputs)
	return "tags"
};